module.exports = __webpack_public_path__ + "img/bg_pic5.b44b8c69.png";